import React from 'react';
import { useConfig } from '../../contexts/ConfigContext.jsx';
import { icons } from '../common/icons.js';
import SocialIcon from '../common/SocialIcon.jsx';

const TopBar = () => {
  const { config } = useConfig();

  return (
    <div className="Topbar">
      <div className="bg-surface border-b border-subtle">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16 gap-4">
            <div className="hidden md:flex items-center justify-center overflow-hidden flex-1 min-w-0 mx-auto">
              <div className="marquee-container w-full">
                <div className="marquee-content whitespace-nowrap">
                  <span className="text-sm lg:text-base text-secondary">
                    {config.brand.taglines[config.brand.activeTagline]}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-end space-x-3 flex-shrink-0">
              <SocialIcon href="https://www.linkedin.com/company/hekaos/" target="_blank" rel="noopener noreferrer" label="LinkedIn" colorClass="text-orange-400 dark:text-orange-200">
                {icons.linkedin}
              </SocialIcon>
              <SocialIcon href="https://x.com/HekaosInc" target="_blank" rel="noopener noreferrer" label="X" colorClass="text-violet-500 dark:text-fuchsia-200">
                {icons.X}
              </SocialIcon>
              <SocialIcon href="https://www.facebook.com/HeKaos/" target="_blank" rel="noopener noreferrer" label="Facebook" colorClass="text-orange-400 dark:text-orange-200">
                {icons.facebook}
              </SocialIcon>
              <SocialIcon href="https://www.instagram.com/hekaos/" target="_blank" rel="noopener noreferrer" label="Instagram" colorClass="text-violet-500 dark:text-fuchsia-300">
                {icons.instagram}
              </SocialIcon>
              <a href="https://hekaos.com" target="_blank" rel="noopener noreferrer" className="accent-amber hover:text-primary transition-colors p-1" aria-label="Hekaos Website">
                {icons.hekaosLarge}
              </a>
              <SocialIcon href="tel:+919235327048" target="_blank" rel="noopener noreferrer" label="Phone" colorClass="text-orange-400 dark:text-orange-200">
                {icons.phone}
              </SocialIcon>
              <SocialIcon href="mailto:hekaosIT@gmail.com" target="_blank" rel="noopener noreferrer" label="Email" colorClass="text-violet-500 dark:text-fuchsia-200">
                {icons.email}
              </SocialIcon>
            </div>
          </div>
        </div>
      </div>
      <div className="md:hidden bg-slate-950 py-2 overflow-hidden">
        <div className="marquee-container">
          <div className="marquee-content whitespace-nowrap">
            <span className="text-xs text-stone-300">{config.brand.taglines[config.brand.activeTagline]}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;

